








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-search'
})
export default class ISearch extends Vue {

  @Prop({type: [String], default: '#9A99A2'}) protected color!: string
}

